import { makeStyles } from '@mui/styles'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    width: '100%',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  
  content: {
    overflowY: 'auto',
    overflowX: 'hidden',
    marginBottom: 20,
  },

  section: {
    marginTop: 10,
    marginBottom: 20,
  },

  sectionTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
    borderRadius: 5,
    color: theme.palette.primary.lighter,
    backgroundColor: theme.palette.primary.main,
    fontSize: '1.7rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    padding: 10,

    '& p': {
      padding: '5px 0 0 5px',

      '& span': {
        fontWeight: 600,
      },
    },
  },

  btnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 20,
    bottom: 15,
  },

  bgc: {
    padding: 10,
  },

  pSection: {
    marginTop: 10,
  },

  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: 4,
    width: '95%',
    marginTop: 20,
    alignSelf: 'center',

    '& thead tr': {
      backgroundColor: '#EFEFEF',
      color: '#000',
      textTransform: 'uppercase',

      '& th': {
        padding: 10,
        textAlign: 'center',
        fontSize: 14,
        width: 120,
        
        '& span': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.25rem',
          '&:last-child':{
            paddingBottom: '3px',
          },
        },

        '&:first-child': {
          borderRadius: '4px 0 0 0',
        },

        '&:last-child': {
          borderRadius: '0 4px 0 0',
        },
      },
    },

    '& tbody tr': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',

      '&:hover': {
        backgroundColor: '#EDEDED',
      },

      '& td': {
        padding: 10,
        fontSize: 14,
        textAlign: 'center',
        cursor: 'pointer',
      },
    },

    '& tfoot tr': {
      '& td': {
        padding: 10,
      },
    },
  },

  score: {
    marginTop: 20,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: -20,

    '& span': {
      fontSize: 14,
    },
  },

  errorCaptured: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 5,
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70vh',
    flexDirection: 'column',
  },

  loadingText: {
    marginTop: 20,
    fontSize: 18,
  },

  notFound: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    height: '100%',
  },
}))

export default styles
